const options = {
	multiselect: {
		allowHTML: true,
		placeholderValue: 'Select...',
		searchPlaceholderValue: 'Search',
		removeItemButton: true,
	},
	multitag: {
		allowHTML: true,
		placeholderValue: 'Digit new value...',
		searchPlaceholderValue: 'Search',
		removeItemButton: true,
	},
	singleselect: {
		allowHTML: true,
		placeholder: true,
		placeholderValue: 'Select...',
		searchPlaceholderValue: 'Select...',
		removeItemButton: false,
		searchEnabled: true,
		shouldSort: false,
	},
};

const ChoicesHook = {
	mounted() {
		initial_options = options[this.el.dataset.type];
		id = this.el.id;
		this.choices = new Choices(this.el, initial_options);
		this.handleEvent('update_' + id, (data) => {
			console.log('data_options: ', data.options);
			this.choices.destroy();
			this.el.innerHTML = this.createOptionsHtml(data.options);
			this.choices = new Choices(this.el, initial_options);
		});
	},
	updated() {
		const newOptionsHtml = this.el.innerHTML;
		this.choices.destroy();
		this.el.innerHTML = newOptionsHtml;
		choices = new Choices(this.el, options[this.el.dataset.type]);
	},
	createOptionsHtml(options) {
		return options.map(opt => 
		  `<option value="${opt.value}">${opt.label}</option>`
		).join('');
	  },
};

export default ChoicesHook;
